"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotosAndAttachmentsToIncludeInPdf = exports.TasksToIncludeInPdf = void 0;
var TasksToIncludeInPdf;
exports.TasksToIncludeInPdf = TasksToIncludeInPdf;

(function (TasksToIncludeInPdf) {
  TasksToIncludeInPdf["ALL"] = "all";
  TasksToIncludeInPdf["NONE"] = "none";
  TasksToIncludeInPdf["INCOMPLETE_ONLY"] = "incompleteOnly";
  TasksToIncludeInPdf["COMPLETE_ONLY"] = "completeOnly";
})(TasksToIncludeInPdf || (exports.TasksToIncludeInPdf = TasksToIncludeInPdf = {}));

var PhotosAndAttachmentsToIncludeInPdf;
exports.PhotosAndAttachmentsToIncludeInPdf = PhotosAndAttachmentsToIncludeInPdf;

(function (PhotosAndAttachmentsToIncludeInPdf) {
  PhotosAndAttachmentsToIncludeInPdf["ALL"] = "all";
  PhotosAndAttachmentsToIncludeInPdf["NONE"] = "none";
})(PhotosAndAttachmentsToIncludeInPdf || (exports.PhotosAndAttachmentsToIncludeInPdf = PhotosAndAttachmentsToIncludeInPdf = {}));